import React from 'react';
import { Box, Text, Button, VStack, HStack, Badge } from '@chakra-ui/react';
import { successButtonProps, secondaryButtonProps } from '../../theme/adminUi';

const formatTime = (seconds) => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

const ServiceProductivityPanel = ({
  title = 'PRODUCTIVIDAD',
  subtitle = null,
  elapsedSeconds = 0,
  isRunning = false,
  isPaused = false,
  isFinalized = false,
  isActive = false,
  canControl = false,
  onPause,
  onResume,
}) => {
  const statusLabel = isFinalized
    ? 'Finalizado'
    : isRunning
      ? 'En marcha'
      : isPaused
        ? 'Pausado'
        : isActive
          ? 'Detenido'
          : '—';

  const statusColor = isFinalized
    ? 'green'
    : isRunning
      ? 'green'
      : isPaused
        ? 'yellow'
        : 'gray';

  return (
    <Box
      w="100%"
      borderWidth="1px"
      borderRadius="md"
      p={3}
      bg="gray.50"
      borderColor="gray.200"
    >
      <HStack justify="space-between" mb={1}>
        <Text fontSize="xs" fontWeight="bold" color="gray.600" letterSpacing="wide">
          {title}
        </Text>
        <Badge colorScheme={statusColor} fontSize="xs" variant="subtle">
          {statusLabel}
        </Badge>
      </HStack>

      {subtitle ? (
        <Text fontSize="xs" color="gray.500" mb={1} noOfLines={1}>
          {subtitle}
        </Text>
      ) : null}

      <Text fontSize="2xl" fontWeight="bold" textAlign="center" mb={1} fontFamily="mono">
        {formatTime(elapsedSeconds)}
      </Text>

      {canControl && (
        <VStack spacing={2}>
          <HStack w="100%">
            {isRunning ? (
              <Button {...secondaryButtonProps} flex={1} onClick={onPause}>
                Pausar
              </Button>
            ) : (
              <Button {...successButtonProps} flex={1} onClick={onResume}>
                Reanudar
              </Button>
            )}
          </HStack>
        </VStack>
      )}
    </Box>
  );
};

export default ServiceProductivityPanel;
